import React from "react";
import { number, bool, string } from "prop-types";

import Icon from "../icon";

const Twitter = ({ width = 28, height = 28, isShareRequired, text }) => (
  <Icon type="twitter" isShareRequired={isShareRequired} text={text}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 28">
      <g transform="translate(-616 -970)">
        <path d="M0 0h28v28H0z" fill="rgba(255,255,255,0)" transform="translate(616 970)" />
        <path
          d="M709.239 197.092a8.606 8.606 0 0 1-2.315.63 3.981 3.981 0 0 0 1.782-2.208 8.22 8.22 0 0 1-2.571.971 4.053 4.053 0 0 0-6.988 2.71 4.161 4.161 0 0 0 .118.907 11.457 11.457 0 0 1-8.322-4.151 3.922 3.922 0 0 0 1.238 5.3 3.906 3.906 0 0 1-1.824-.491v.053a3.756 3.756 0 0 0 .277 1.43 4.024 4.024 0 0 0 2.966 2.457 3.97 3.97 0 0 1-1.067.149 3.6 3.6 0 0 1-.758-.085 4.07 4.07 0 0 0 3.767 2.774 8.164 8.164 0 0 1-5 1.7c-.331 0-.64-.022-.97-.054a11.647 11.647 0 0 0 6.188 1.782 11.228 11.228 0 0 0 11.212-8.9 10.923 10.923 0 0 0 .267-2.4v-.512a8.344 8.344 0 0 0 2.006-2.059z"
          fill="#fff"
          fillRule="evenodd"
          transform="translate(-69.048 781.19)"
        />
      </g>
    </svg>
  </Icon>
);

Twitter.propTypes = {
  width: number,
  height: number,
  isShareRequired: bool,
  text: string,
};

export default Twitter;
